import React from 'react';
import styled from 'styled-components';

const SpacingWrapper = styled.span``;

const Spacing = () => <SpacingWrapper>&nbsp;</SpacingWrapper>;

export default Spacing;
